import { render, staticRenderFns } from "./FormHeader.vue?vue&type=template&id=7029b40a&scoped=true&"
import script from "./FormHeader.vue?vue&type=script&lang=ts&"
export * from "./FormHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7029b40a",
  null
  
)

export default component.exports